import React from 'react';
import s from '../../pages/PDV.module.css';

export default function ModalObservacao({ modalObs, setModalObs, obsTexto, setObsTexto }) {
  if (!modalObs) return null;
  return (
        <div className={s.modalOverlay} onClick={() => setModalObs(false)}>
          <div className={s.modalObservacao} onClick={e => e.stopPropagation()}>
            <div className={s.modalTitleBar}>
              <span>Observação da Venda</span>
              <button className={s.modalClose} onClick={() => setModalObs(false)}>✕</button>
            </div>
            <div className={s.obsBody}>
              <textarea
                className={s.obsTextarea}
                autoFocus
                value={obsTexto}
                onChange={e => setObsTexto(e.target.value)}
                placeholder="Digite uma observação para esta venda…"
                rows={5}
              />
            </div>
            <div className={s.modalFooter}>
              <button className={s.btnConsumidor} onClick={() => setModalObs(false)}>Salvar</button>
              <button className={s.btnCancelarModal} onClick={() => { setObsTexto(''); setModalObs(false); }}>Cancelar</button>
            </div>
          </div>
        </div>
  );
}
